<template>
  <div class="invite-cpn"
       v-loading="loading">
    <div class="banner-img-area">
      <img :src="inviteBannerImg"
           alt=""
           style="width: 100%">
      <div class="have-invite-code-area">
        <div class="header">🔑 我有邀请码，去验证</div>
        <div class="input-section">
          <el-tooltip class="item"
                      effect="dark"
                      :content="disableContent"
                      :disabled="canInvite"
                      placement="bottom">
            <el-input type="text"
                      placeholder="输入邀请码"
                      :disabled="!canInvite"
                      v-model="inviteCode"
                      size="mini"
                      style="width: 180px;margin-right: 10px" />
          </el-tooltip>
          <el-button @click="validateInviteCode"
                     size="mini"
                     type="success">验证</el-button>
        </div>
      </div>
    </div>
    <div class="invite-page-area">
      <div class="header">
        <p style="font-weight: 500;margin: 0.5em">🎁 邀请新人体验镜界AI获得额外提问次数！</p>
        <p style="font-weight: 500;margin: 0.5em">🔍和好友一起加入镜界AI，为消费市场数据洞察提效</p>
        <p style="font-weight: 400;margin: 0.5em;font-size: 14px;color: #595B61">tips：同时将镜界回答下载为文档发给好友，更有吸引力哦</p>
      </div>
      <!-- 邀请码验证部分 -->
      <div class="invite-code-section">
        <div style="font-size: 14px;color: #595B61">
          镜界AI（<a style="text-decoration: underline">ai.mktindex.com</a>）——专为消费品商业分析打造的AI分析师，使用我的邀请码获得3次额外提问机会！快来试试吧！
        </div>
        <div class="my-invite-code">
          <div>我的邀请码：</div>
          <div style="margin-right: 30px">{{ myInviteCode }}</div>

        </div>
        <div style="display: flex; justify-content: flex-end">
          <el-button @click="copyInviteCode"
                     type="primary"
                     style="padding: 8px 20px;letter-spacing: 3px"
                     size="mini">一键复制</el-button>
        </div>

      </div>
      <!-- 邀请记录表格 -->
      <div class="invite-record">
        <div style="margin-bottom: 10px">我的邀请记录</div>
        <el-table :data="tableData"
                  :max-height="400"
                  stripe
                  border
                  fit>
          <el-table-column align="center"
                           prop="index"
                           label="序号">
          </el-table-column>
          <el-table-column prop="phone"
                           label="手机号"
                           v-if="!isJdUser">
          </el-table-column>
          <el-table-column prop="nickname"
                           label="被邀请人"
                           v-if="isJdUser">
          </el-table-column>
          <el-table-column prop="ts"
                           label="邀请成功时间">
          </el-table-column>
          <el-table-column prop="reward"
                           label="获取奖励">
          </el-table-column>
        </el-table>
      </div>
      <!-- 邀请规则 -->
      <div class="invite-rules">
        <p style="font-size: 16px;font-weight: 500">邀请规则</p>
        <p style="font-size: 14px;font-weight: 400">
          1.您的好友在首次登录镜界30天内验证您的邀请码，您和好友将分别获得3次提问机会。
        </p>
        <p style="font-size: 14px;font-weight: 400">
          2. 奖励无上限，邀请好友越多，奖励越多！
        </p>
        <p style="font-size: 14px;font-weight: 400">
          3. 奖励提问次数无使用期限。
        </p>
        <p style="color: #5F6670">有其他疑问? <span style="text-decoration: underline;cursor: pointer"
                @click="openHelpDialog">联系客服</span></p>
      </div>
    </div>

  </div>
</template>


<script>
import { postInviteCode, postUserInviteList } from '@/api/public.js'
export default {
  name: 'Invite',
  data() {
    return {
      loading: false,
      remain: '',
      tableData: [],
      inviteBannerImg: require('@/assets/invite-banner.jpeg'),
      myInviteCode: '',
      inviteCode: '',
      canInvite: false,
      disableContent: '仅注册一个月内新用户可验证邀请',
    }
  },
  props: {},
  computed: {
    isJdUser() {
      return this.$store.state.user.isJdUser
    },
  },
  methods: {
    openHelpDialog() {
      this.$emit('openHelpDialog')
    },
    validateInviteCode() {
      if (!this.inviteCode) {
        this.$message.warning('请输入邀请码')
        return
      }
      postInviteCode({
        invite_code: this.inviteCode.trim(),
      })
        .then((res) => {
          if (res.status == 'ok') {
            const result = res.result
            const message = result.message
            if (message.indexOf('验证成功') > -1) {
              this.$message.success(message)
            } else {
              this.$message.error(message)
            }
          }
        })
        .catch((err) => {
          this.$message.error('请求报错')
        })
    },
    async copyInviteCode() {
      try {
        let text = `镜界AI（ai.mktindex.com）——专为消费品商业分析打造的AI分析师，使用我的邀请码获得3次额外提问机会！快来试试吧！
我的邀请码：${this.myInviteCode}`
        // 使用 navigator.clipboard API 复制文本
        await navigator.clipboard.writeText(text)
        this.$message.success('已成功复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败')
      }
    },
  },
  created() {},
  mounted() {},
  watch: {
    '$store.state.user.chatId': {
      handler(newVal) {
        if (newVal == 'invite') {
          postUserInviteList()
            .then((res) => {
              if (res.status == 'ok') {
                const result = res.result
                this.myInviteCode = result.invite_code
                this.tableData = result.invite_people.map((item, index) => {
                  const temp = {}
                  temp.index = index + 1
                  temp.phone = item.phone_number
                  temp.reward = item.reward_obtained
                  temp.nickname = item.nickname
                  temp.ts = item.invited_time
                  return temp
                })
                this.canInvite =
                  !result.has_verified_invite_code && result.is_new_user
                if (result.has_verified_invite_code) {
                  this.disableContent = '每位用户仅可验证一次邀请码'
                }
              }
            })
            .catch((err) => {})
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="less">
.invite-cpn {
  height: calc(100% - 60px);
  overflow-y: auto;
  align-items: center;
  background-color: #fff;
  padding: 40px 80px;
  .banner-img-area {
    width: 100%;
    position: relative;
    .have-invite-code-area {
      width: 340px;
      height: 80px;
      position: absolute;
      bottom: -220px;
      right: 40px;
      box-shadow: #bababa 0px 4px 12px 0;
      padding: 40px;
      background-color: #f9f9f9;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-radius: 15px;
      .header {
        text-align: center;
        font-size: 18px;
        margin-bottom: 15px;
        p {
          margin: 5px;
        }
      }
    }
  }
  .invite-page-area {
    width: 50%;
    .header {
      text-align: left;
      margin-bottom: 40px;

      font-size: 16px;

      p {
        color: #666;
      }
    }
  }
  .invite-code-section {
    background-color: #e9ecf1;
    font-size: 18px;
    margin-bottom: 40px;
    padding: 20px;
    .my-invite-code {
      display: flex;
      align-items: center;
      font-weight: 400;
      margin-top: 15px;
      margin-bottom: 10px;
    }
  }
  .invite-record {
    font-size: 16px;
    margin-bottom: 40px;
  }
  .el-table thead {
    color: #000;
  }
  .el-table tr {
    background-color: #f9f9f9;
  }
  .el-table tr:nth-child(even) {
    background-color: #ffffff;
  }
  .el-table--striped
    .el-table__body
    tr.el-table__row--striped
    td.el-table__cell {
    background-color: #ffffff;
  }
  .el-table .el-table__cell {
    padding: 5px 0;
  }
  .el-table th.el-table__cell {
    background-color: #e9ecf1;
    padding: 5px;
    font-size: 14px;
  }
  .invite-rules {
    background-color: #e9ecf1;
    padding: 20px;
    margin-bottom: 60px;
  }
  .el-table--enable-row-transition .el-table__body td.el-table__cell {
    border: none;
  }
}
</style>
